import React, { useState } from 'react';
import LazilyRender from 'react-lazily-render';
import { startUfoExperience } from '../../../state/analytics/ufoExperiences';
import { CardWithUrlContent } from '../component';
import { LoadingCardLink } from './LoadingCardLink';
export function LazyLazilyRenderCard(props) {
  var appearance = props.appearance,
    container = props.container,
    id = props.id;
  var offset = Math.ceil(window.innerHeight / 4);
  useState(function () {
    // Start of experience when intersectionObserver is not supported.
    startUfoExperience('smart-link-rendered', id);
  });
  return /*#__PURE__*/React.createElement(LazilyRender, {
    offset: offset,
    component: appearance === 'inline' ? 'span' : 'div'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "loader-wrapper",
    placeholder: /*#__PURE__*/React.createElement(LoadingCardLink, props),
    scrollContainer: container,
    content: /*#__PURE__*/React.createElement(CardWithUrlContent, props)
  });
}